import { render, staticRenderFns } from "./DriverFileForm.vue?vue&type=template&id=22889de6&scoped=true"
import script from "./DriverFileForm.vue?vue&type=script&lang=js"
export * from "./DriverFileForm.vue?vue&type=script&lang=js"
import style0 from "./DriverFileForm.vue?vue&type=style&index=0&id=22889de6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22889de6",
  null
  
)

export default component.exports